import { PostForm } from "./form";

const CreatePost = () => {

  return <PostForm />;
};

export default CreatePost;
